import { render } from "./Header.vue?vue&type=template&id=65be3f7e"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=65be3f7e&lang=scss"

import exportComponent from "D:\\Nerd\\RumbleFish\\Website\\Code\\rumblefish\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__